export default __webpack_public_path__ + "static/media/add-to-playlist-blue.fa972d7f.svg";